import { forwardRef, type SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { Icon } from '@/shared/components/Icon';
import { cn } from '@/shared/helpers/cn';
import styles from './Select.module.scss';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  options: readonly SelectOption[];
  /** Texto da opcao vazia. Omita quando o campo nao aceitar ausencia. */
  placeholder?: string;
  invalid?: boolean;
}

/** Selecao de opcao unica, sobre o `<select>` nativo. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, placeholder, invalid, className, ...rest },
  ref,
) {
  return (
    <div className={cn(styles.wrapper, invalid && styles.invalid, className)}>
      <select ref={ref} className={styles.select} {...rest}>
        {placeholder ? <option value="">{placeholder}</option> : null}
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      <span className={styles.chevron}>
        <Icon as={ChevronDown} size={16} />
      </span>
    </div>
  );
});
